import { useContext } from 'react';
import { TableUpdateContext } from '../../contexts/reviewTypeContext';
import { ReviewType, UpdatePhase } from '../financialTables/configuration/constants';
import { BranchSettingContext } from '../../contexts/branchSettingsContext';
import { SUPPORTED_DATA } from '../../pages/admin/company/stores/peersReportsStore/constants';
import AuthService from '../../service/auth';
import { ROLES } from '../../constnats/user';

const BranchSettingsProvider = ({ currentSchemaId, children }) => {
    const tableUpdateContext = useContext(TableUpdateContext);
    const reviews = tableUpdateContext.reviews;
    const currentReview = reviews.find((r) => r.schemaId == currentSchemaId);
    const isAutoImportSupported = currentReview?.type !== ReviewType.CORE_DATA_CHECK;
    const branchSubtitle = currentReview ? `This Review is for ${currentReview.type}` : '';
    const supportedData = currentReview?.type === ReviewType.CORE_DATA_CHECK
            ? [SUPPORTED_DATA.CD]
            : [SUPPORTED_DATA.CD, SUPPORTED_DATA.FIELD_SRC, SUPPORTED_DATA.REPORTED_AS_LABELS];
    const permissions = {
        qa: {
            read:
                tableUpdateContext.updatePhase === UpdatePhase.READY_FOR_QA_REVIEW &&
                reviews.some((r) => r.type === ReviewType.VISUAL_CHECK && r.ownerId === AuthService.getUserId()) &&
                AuthService.hasAnyGlobalRole([ROLES.QA]),
        },
    };

    return (
        <BranchSettingContext.Provider
            value={{
                supportedData,
                isAutoImportSupported,
                branchSubtitle,
                permissions,
                branchSchemaId: currentSchemaId,
            }}
        >
            {children}
        </BranchSettingContext.Provider>
    );
};

export default BranchSettingsProvider;
